import Form from 'components/Form';

import RowContainer from '../components/RowContainer';
import RowContent from '../components/RowContent';
import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';
import SectionTitle from '../components/SectionTitle';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
}

const Info = (props: Props) => {
  const { disabled, setValue, getValues, register, watch } = props;

  const infos = [
    { title: '요양기관명', value: 'no01_organization_name' },
    { title: '병동코드', value: 'no01_ward_code' },
    { title: '작성일자', value: 'no01_date' },
    { title: '작성자명', value: 'no01_name' },
    { title: '작성자 부서', value: 'no01_dept' },
    { title: '작성자 연락처', value: 'no01_contact' },
  ];

  return (
    <>
      <SectionTitle
        title="1. 요양기관 명, 종별, 병동코드, 작성자 관련 정보"
        mb={3}
        mt={3}
      />

      <RowContainer xs={11.5} sx={{ marginLeft: '20px' }}>
        {infos.map(({ title, value }) => {
          if (title === '작성일자') {
            return (
              <RowContent title={title} titleRatio={1} childrenRatio={2.8}>
                <Form.MuiTextField
                  disabled={disabled}
                  required={false}
                  type="date"
                  {...register(`${value}`)}
                />
              </RowContent>
            );
          }
          return (
            <RowContent title={title} titleRatio={1} childrenRatio={2.8}>
              <Form.MuiTextField
                disabled={disabled}
                required={false}
                placeholder="직접 입력"
                {...register(`${value}`)}
              />
            </RowContent>
          );
        })}
      </RowContainer>
    </>
  );
};

export default Info;
